import clsx from 'clsx';

import type { Adaptive } from '../types/Adaptive';
import type { Radius } from '../types/Radius';

export function composeEndRadiusClasses(radius: Adaptive<Radius>): string {
    if (typeof radius === 'object') {
        return clsx(
            radius.base && `rounded-e-${radius.base}`,
            radius.sm && `sm:rounded-e-${radius.sm}`,
            radius.md && `md:rounded-e-${radius.md}`,
            radius.lg && `lg:rounded-e-${radius.lg}`,
            radius.xl && `xl:rounded-e-${radius.xl}`,
            radius['2xl'] && `2xl:rounded-e-${radius['2xl']}`
        );
    }

    return `rounded-e-${radius}`;
}
